module.exports = __webpack_public_path__ + "static/media/amenities_sprite2.7a46edd7.svg";